import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-24 text-left" data-testid="not-found-page">
      <p className="eyebrow">404</p>
      <h1 className="mt-4 text-4xl sm:text-5xl text-[#1a261f]">This path leads nowhere.</h1>
      <Link to="/" className="mt-8 inline-block link-u text-[#1f402b]" data-testid="not-found-home-link">Back to home</Link>
    </div>
  );
}
